import React from 'react'

export default function StrategicAlerts({ expediente = {}, strategicRules = null, onOpenCareModule }) {
  const meta = strategicRules?.caseMeta || {}
  const isFemenino = String(expediente?.sexo || '').toUpperCase() === 'F'
  const showCareSuggestion = Boolean(isFemenino && meta.subsanacionActive)
  const faltanMeses = Math.max(0, Math.ceil((30 - Number(meta.aporteAnios || 0)) * 12))

  if (!showCareSuggestion && !meta.subsanacionActive) return null

  return (
    <div className="mt-4 space-y-3 rounded-2xl border border-white/20 bg-white/10 p-4 backdrop-blur-2xl">
      {showCareSuggestion && (
        <div className="rounded-xl border border-emerald-300/40 bg-emerald-500/20 p-3 text-emerald-100">
          <p className="text-sm font-semibold">Sugerencia: Se detecto brecha contributiva.</p>
          <p className="mt-1 text-xs">Desea aplicar el modulo de Tareas de Cuidado (Dto. 475/21)?</p>
          <button
            type="button"
            onClick={() => onOpenCareModule?.()}
            className="mt-2 rounded-lg border border-emerald-200/50 bg-emerald-300/20 px-3 py-1.5 text-xs font-semibold text-emerald-50"
          >
            Completar Tareas de Cuidado
          </button>
        </div>
      )}

      {meta.subsanacionActive && (
        <div className="rounded-xl border border-amber-300/40 bg-amber-500/20 p-3 text-amber-100">
          <p className="text-sm font-semibold">Oportunidad de Subsanacion</p>
          <p className="mt-1 text-xs">Faltan aproximadamente {faltanMeses} meses de aportes. Puede evaluarse regularizacion por Ley 27.705.</p>
        </div>
      )}
    </div>
  )
}
